export const newsItems = [
    {
        date: '28 May 2026',
        text: 'Our paper, “𝐀 𝐋𝐢𝐠𝐡𝐭𝐰𝐞𝐢𝐠𝐡𝐭 𝐃𝐢𝐠𝐢𝐭𝐚𝐥-𝐓𝐰𝐢𝐧-𝐁𝐚𝐬𝐞𝐝 𝐅𝐫𝐚𝐦𝐞𝐰𝐨𝐫𝐤 𝐟𝐨𝐫 𝐄𝐝𝐠𝐞-𝐀𝐬𝐬𝐢𝐬𝐭𝐞𝐝 𝐕𝐞𝐡𝐢𝐜𝐥𝐞 𝐓𝐫𝐚𝐜𝐤𝐢𝐧𝐠 𝐚𝐧𝐝 𝐂𝐨𝐥𝐥𝐢𝐬𝐢𝐨𝐧 𝐏𝐫𝐞𝐝𝐢𝐜𝐭𝐢𝐨𝐧,” has received the 𝐁𝐞𝐬𝐭 𝐏𝐚𝐩𝐞𝐫 𝐀𝐰𝐚𝐫𝐝 at the 4th Workshop on Data Driven and AI-Enabled Digital Twin Networks and Applications (TwinNetApp), held in conjunction with IEEE ICC 2026 in Glasgow ',
        link: 'https://www.linkedin.com/posts/bkantarci_ieeeicc2026-twinnetapp-digitaltwins-activity-7465770598544162816-O1_V?utm_source=share&utm_medium=member_desktop&rcm=ACoAACyF8uIBKEnpxtMMibCjBEShnwyd1GbxSkM'
    },
    {
        date: '18 May 2026',
        text: 'Prof. Kantarci received IEEE Canada J. M. Ham Outstanding Engineering Educator Silver Medal Award 18 May 2026',
        link: 'https://www.linkedin.com/posts/%F0%9D%90%88%F0%9D%90%84%F0%9D%90%84%F0%9D%90%84-%F0%9D%90%82%F0%9D%90%9A%F0%9D%90%A7%F0%9D%90%9A%F0%9D%90%9D%F0%9D%90%9A-2026-%F0%9D%90%80%F0%9D%90%9C%F0%9D%90%A1%F0%9D%90%A2%F0%9D%90%9E-ugcPost-7469287219418157059-Xvz6/?utm_source=share&utm_medium=member_ios&rcm=ACoAAAUoPKMBd8n4Mb9tDhP5gjxDMGVkcPdDboE'
    },

    {
        date: '26 March 2026',
        text: 'Dr. Kantarci is the recipient of the 𝟐𝟎𝟐𝟔 𝐄𝐧𝐠𝐢𝐧𝐞𝐞𝐫𝐢𝐧𝐠 𝐄𝐱𝐜𝐞𝐥𝐥𝐞𝐧𝐜𝐞 𝐀𝐰𝐚𝐫𝐝 𝐨𝐟 𝐏𝐫𝐨𝐟𝐞𝐬𝐬𝐢𝐨𝐧𝐚𝐥 𝐄𝐧𝐠𝐢𝐧𝐞𝐞𝐫𝐬 𝐎𝐧𝐭𝐚𝐫𝐢𝐨 (𝐏𝐄𝐎)-Ottawa Section',
        link: 'https://www.linkedin.com/posts/researchimpact-engineering-innovation-share-7443359097074237440-vpnY?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAUoPKMBd8n4Mb9tDhP5gjxDMGVkcPdDboE'
    },

    {
        date: '25 November 2025',
        text: 'Our member Murat Arda Onsu has earned an 𝐇𝐨𝐧𝐨𝐫𝐚𝐫𝐲 𝐌𝐞𝐧𝐭𝐢𝐨𝐧 𝐢𝐧 𝐭𝐡𝐞 𝟐𝟎𝟐𝟓 𝐈𝐄𝐄𝐄 𝐂𝐨𝐦𝐒𝐨𝐜 𝐒𝐭𝐮𝐝𝐞𝐧𝐭 𝐂𝐨𝐦𝐩𝐞𝐭𝐢𝐭𝐢𝐨𝐧 \"Communications Technology Changing the World\" with the project entitled \"Unleashing Semantic Communications for Urban Traffic Collision Avoidance\" (a part of our collaboration with Nokia Bell Labs). Congratulations!',
        link: 'https://www.comsoc.org/membership/ieee-comsoc-student-competition/winners'
    },
    {
        date: '13 November 2025',
        text: 'Two of our members receive prestigious scholarships. Ghazal Asemian receives 𝐐𝐮𝐞𝐞𝐧 𝐄𝐥𝐢𝐳𝐚𝐛𝐞𝐭𝐡 𝐈𝐈 𝐆𝐫𝐚𝐝𝐮𝐚𝐭𝐞 𝐒𝐜𝐡𝐨𝐥𝐚𝐫𝐬𝐡𝐢𝐩 𝐢𝐧 𝐒𝐜𝐢𝐞𝐧𝐜𝐞 𝐚𝐧𝐝 𝐓𝐞𝐜𝐡𝐧𝐨𝐥𝐨𝐠𝐲, Didem Cicek Simsek receives 𝐎𝐧𝐭𝐚𝐫𝐢𝐨 𝐆𝐫𝐚𝐝𝐮𝐚𝐭𝐞 𝐒𝐜𝐡𝐨𝐥𝐚𝐫𝐬𝐡𝐢𝐩 (𝐎𝐆𝐒).  Congratulations!',
        link: 'https://www.linkedin.com/posts/faculty-of-engineering-uottawa_uottawaengineering-uottawaengineering-uottawagenie-activity-7396216215242784768-vRbB?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAUoPKMBd8n4Mb9tDhP5gjxDMGVkcPdDboE'
    },
    {
        date: '31 October 2025',
        text: 'Prof. Kantarci receives IEEE Ottawa Section 𝐎𝐮𝐭𝐬𝐭𝐚𝐧𝐝𝐢𝐧𝐠 𝐄𝐧𝐠𝐢𝐧𝐞𝐞𝐫𝐢𝐧𝐠 𝐄𝐝𝐮𝐜𝐚𝐭𝐨𝐫 𝐀𝐰𝐚𝐫𝐝',
        link: 'https://www.linkedin.com/posts/faculty-of-engineering-uottawa_ieee-education-engineering-activity-7391154642656714752-DIKH?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAUoPKMBd8n4Mb9tDhP5gjxDMGVkcPdDboE'
    },
    {
        date: '3 October 2025',
        text: 'Our lab\'s postdoctoral researcher Dr. Poonam Lohan was spotlighted by \"𝐖𝐨𝐦𝐞𝐧 𝐢𝐧 𝟔𝐆 𝐭𝐨𝐩-𝟓 𝐑𝐞𝐬𝐞𝐚𝐫𝐜𝐡 𝐏𝐢𝐜𝐤𝐬 𝐨𝐟 𝐭𝐡𝐞 𝐌𝐨𝐧𝐭𝐡\"  for the work FLARE: Flying Learning Agents for Resource Efficiency in Next-Gen UAV Networks,” along with Xuli Cai, and Burak Kantarci.',
        link: 'https://www.linkedin.com/posts/womenin6g_womenin6g-6g-womeninstem-activity-7379813737618313216-FDka?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAUoPKMBd8n4Mb9tDhP5gjxDMGVkcPdDboE'
    },
    {
        date: '16 July 2025',
        text: 'Our lab\'s postdoctoral researcher Poonam Lohan has been elevated to IEEE Senior Member status. Congratulations!',
        link: ''
    },
    {
        date: '11 February 2025',
        text: 'Dr .Kantarci has been awarded the King Charles III Coronation Medal by the Governor General of Canada (nominated by Universities Canada). This medal is awarded to individuals who have made a significant contribution to Canada, a specific region, or a community, or who have achieved outstanding accomplishments abroad that bring credit to Canada.',
        link: 'https://univcan.ca/news/universities-canada-congratulates-recipients-of-the-king-charles-iii-coronation-medal/'
    },
    {
        date: '11 December 2024',
        text: 'Dr. Kantarci wins the 2024-2025 George S. Glinski Award for Excellence in Research in the Faculty of Engineering at the University of Ottawa. Details about the public lecture for the award during the award ceremony will be announced soon.',
        link: ''
    },
    {
        date: '11 December 2024',
        text: 'Our collaborative work("𝐄𝐝𝐠𝐞 𝐋𝐞𝐚𝐫𝐧𝐢𝐧𝐠 𝐟𝐨𝐫 𝟔𝐆-𝐄𝐧𝐚𝐛𝐥𝐞𝐝 𝐈𝐧𝐭𝐞𝐫𝐧𝐞𝐭 𝐨𝐟 𝐓𝐡𝐢𝐧𝐠𝐬: 𝐀 𝐂𝐨𝐦𝐩𝐫𝐞𝐡𝐞𝐧𝐬𝐢𝐯𝐞 𝐒𝐮𝐫𝐯𝐞𝐲 𝐨𝐟 𝐕𝐮𝐥𝐧𝐞𝐫𝐚𝐛𝐢𝐥𝐢𝐭𝐢𝐞𝐬, 𝐃𝐚𝐭𝐚𝐬𝐞𝐭𝐬, 𝐚𝐧𝐝 𝐃𝐞𝐟𝐞𝐧𝐬𝐞𝐬") in IEEE Communications Surveys and Tutorials has received the IEEE ComSoc Communications Systems Integration and Modeling Technical Committee (CSIM-TC) 2024 Best Journal Paper Award. ',
        link: 'https://ieeexplore.ieee.org/document/10255264'
    },

    {
        date: '3 December 2024',
        text: 'New article of Ottawa Business Journal, "How uOttawa empowers local startup success through R&D collaborations", is available at:',
        link: 'https://obj.ca/how-uottawa-empowers-local-startup-success-through-rd-collaborations/'
    },
    {
        date: '22 November 2024',
        text: 'Our paper in collaboration with CIENA ("𝐀 𝐍𝐞𝐰 𝐑𝐞𝐚𝐥𝐢𝐬𝐭𝐢𝐜 𝐏𝐥𝐚𝐭𝐟𝐨𝐫𝐦 𝐟𝐨𝐫 𝐁𝐞𝐧𝐜𝐡𝐦𝐚𝐫𝐤𝐢𝐧𝐠 𝐚𝐧𝐝 𝐏𝐞𝐫𝐟𝐨𝐫𝐦𝐚𝐧𝐜𝐞 𝐄𝐯𝐚𝐥𝐮𝐚𝐭𝐢𝐨𝐧 𝐨𝐟 𝐃𝐑𝐋-𝐃𝐫𝐢𝐯𝐞𝐧 𝐚𝐧𝐝 𝐑𝐞𝐜𝐨𝐧𝐟𝐢𝐠𝐮𝐫𝐚𝐛𝐥𝐞 𝐒𝐅𝐂 𝐏𝐫𝐨𝐯𝐢𝐬𝐢𝐨𝐧𝐢𝐧𝐠 𝐒𝐨𝐥𝐮𝐭𝐢𝐨𝐧𝐬,") has received the Best Paper Award at IEEE Globecom 2024, one of the flagship conferences of the IEEE Communications Society. Congratulations to all co-authors: Murat Arda Onsu, Poonam Lohan, Burak Kantarci, Emil Janulewicz, Sergio Slobodrian',
        link: 'https://www.linkedin.com/posts/bkantarci_ieeeglobecom2024-bestpaperaward-collaboration-activity-7267238368105611266-PLPs?utm_source=share&utm_medium=member_desktop'
    },
    {
        date: '18 September 2024',
        text: 'IEEE Systems Council Distinguished Lecture, "What\'s next for AI-Enabled Security/Safety of Critical Infrastructures? Beyond 5G and at the Dawn of 6G.", from Professor Burak Kantarci is available.',
        link: 'https://ieeesystemscouncil.org/presentation/webinar/whats-next-ai-enabled-securitysafety-critical-infrastructures-beyond-5g-and'
    },
    {
        date: '3 September 2024',
        text: 'New provincial funding to help drive connected and autonomous vehicle research led by Smart Connected Vehicles Innovation Centre at uOttawa ',
        link: 'https://www.uottawa.ca/about-us/news-all/new-provincial-funding-help-drive-connected-autonomous-vehicle-research-uottawa'
    },
    {
        date: '21 June 2024',
        text: 'The CREATE TRAVERSAL Workshop, held at the Smart Connected Vehicles Innovation Centre on June 20-21, was open to the public and featured strong participation from industry, academia, and the broader community. You can watch the opening session here:',
        link: 'https://www.youtube.com/watch?v=rlpRz1L9cls&t=119s'
    },
    {
        date: '28 May 2024',
        text: 'During the fifth anniversary of the uOttawa-Kanata North campus, the Smart Connected Vehicles Innovation Centre welcomed guests and shared its vision and story.',
        link: 'https://www.youtube.com/watch?v=UZjw23oOAAk&feature=youtu.be'
    },
    {
        date: '15 Jan 2024',
        text: 'Dr. Kantarci has been selected for the IEEE Communications Software Technical Committee - 2023 Technical Achievement Award for contributions to "contributions to AI/ML-enabled communication network security and trustworthy sensing systems for the Internet of Things"',
        link: ''
    },
    {
        date: '01 Dec 2023',
        text: 'Our paper entitled "𝐆𝐞𝐧𝐞𝐫𝐚𝐭𝐢𝐯𝐞 𝐀𝐝𝐯𝐞𝐫𝐬𝐚𝐫𝐢𝐚𝐥 𝐍𝐞𝐭𝐰𝐨𝐫𝐤𝐬 𝐭𝐨 𝐒𝐞𝐜𝐮𝐫𝐞 𝐕𝐞𝐡𝐢𝐜𝐥𝐞-𝐭𝐨-𝐌𝐢𝐜𝐫𝐨𝐠𝐫𝐢𝐝 𝐒𝐞𝐫𝐯𝐢𝐜𝐞𝐬" has received the Best Student Paper Award in IEEE Virtual Conference on Communications (VCC 2023). Congratulations to PhD student Ahmed Omara! For news release',
        link: 'https://vcc2023.ieee-vcc.org/news/best-papers'
    },
    
    {
        date: '19 Sep 2023',
        text: 'Our comprehensive survey on Edge Learning for 6G-Enabled Internet of Things in Communications Surveys and Tutorials is now available online. Have a look.',
        link: 'https://ieeexplore.ieee.org/document/10255264'
    },
    
    {
        date: '29 May 2023',
        text: 'Our paper in collaboration\'ini with NETCORE Lab\'s Melike Erol-Kantarci and Pedro Ituria Rivera and NetExperience\'s Marcel Chenier and Berhard Herscovici ("𝐑𝐋 𝐦𝐞𝐞𝐭𝐬 𝐌𝐮𝐥𝐭𝐢-𝐋𝐢𝐧𝐤 𝐎𝐩𝐞𝐫𝐚𝐭𝐢𝐨𝐧 𝐢𝐧 𝐈𝐄𝐄𝐄 𝟖𝟎𝟐.𝟏𝟏𝐛𝐞: 𝐌𝐮𝐥𝐭𝐢-𝐇𝐞𝐚𝐝𝐞𝐝 𝐑𝐞𝐜𝐮𝐫𝐫𝐞𝐧𝐭 𝐒𝐨𝐟𝐭-𝐀𝐜𝐭𝐨𝐫 𝐂𝐫𝐢𝐭𝐢𝐜-𝐛𝐚𝐬𝐞𝐝 𝐓𝐫𝐚𝐟𝐟𝐢𝐜 𝐀𝐥𝐥𝐨𝐜𝐚𝐭𝐢𝐨𝐧") has received the Best Paper Award in IEEE International Conference on Communications (ICC 2023) NGNI symposium.',
        link: ''
    },
    
    {
        date: '18 Apr 2023',
        text: 'Dr. Kantarci has been awarded -as the lead PI, NSERC CREATE grant to lead the project Training and Research in Autonomous Vehicles for Reliable Services in the Air and on Land (TRAVERSAL). For news release',
        link: 'https://www.uottawa.ca/research-innovation/news-all/uottawa-push-boundaries-quantum-research-autonomous-vehicle-technology-nserc-grants'
    },
    
    {
        date: '14 Mar 2023',
        text: 'Our article entitled "Secure Industrial IoT Systems via RF Fingerprinting Under Impaired Channels With Interference and Noise" is now available in IEEExplore. Congratulations to the team! To view the article.',
        link: 'https://ieeexplore.ieee.org/document/10068504'
    },
    
    {
        date: '13 Mar 2023',
        text: 'Dr. Kantarci is listed among top Computer Scientists in Canada in 2022 (To view at Research.com.)',
        link: 'https://research.com/scientists-rankings/computer-science/ca?page=4'
    },
    
    {
        date: '06 Mar 2023',
        text: 'Our article entitled "A Continuous Actor-Critic Deep Q-Learning-Enabled Deployment of UAV Base Stations: Toward 6G Small Cells in the Skies of Smart Cities" is now available in IEEE O. Journal of the Communications Society. Congratulations Nahid!',
        link: 'https://ieeexplore.ieee.org/document/10059153'
    },
    
    {
        date: '01 Feb 2023',
        text: 'Our article entitled "Distributed denial of service attack prediction: Challenges, open issues and opportunities" is now available in Elsevier Computer Networks. Thank you Prof. Michele Nogueira for this fruitful collaboration,and congrats Anderson de Neira!',
        link: 'https://www.sciencedirect.com/science/article/abs/pii/S1389128622005874'
    },
    
    {
        date: '18 Nov 2022',
        text: 'Dr. Kantarci is leading two DND IDEaS projects to achieve stronger and more secure 5G-enabled infrastructures in collaboration with leading indsutry partners. $3M IDEaS DND funding advances 5G security research.',
        link: 'https://www2.uottawa.ca/about-us/media/news/driving-future-3m-ideas-dnd-funding-advances-5g-security-research-uottawa'
    },
    
    {
        date: '09 Nov 2022',
        text: 'We received the Best Paper Award in Wireless World Research Forum Meeting #48 with our work entitled "𝐎𝐧 𝐭𝐡𝐞 𝐈𝐦𝐩𝐚𝐜𝐭 𝐨𝐟 𝐂𝐃𝐋 𝐚𝐧𝐝 𝐓𝐃𝐋 𝐀𝐮𝐠𝐦𝐞𝐧𝐭𝐚𝐭𝐢𝐨𝐧 𝐟𝐨𝐫 𝐑𝐅 𝐅𝐢𝐧𝐠𝐞𝐫𝐩𝐫𝐢𝐧𝐭𝐢𝐧𝐠 𝐮𝐧𝐝𝐞𝐫 𝐈𝐦𝐩𝐚𝐢𝐫𝐞𝐝 𝐂𝐡𝐚𝐧𝐧𝐞𝐥𝐬". Congratulations to all co-authors: O. M. Gul, M. Kulhandjian . B Kantarci, C. D\'Amours, A. Touazi, C. Ellement. To view the full story.',
        link: 'https://www.linkedin.com/posts/bkantarci_it-is-a-true-honour-to-receive-the-best-paper-activity-6996108588423274496-kir4?utm_source=share&utm_medium=member_desktop'
    },
    {
        date: '18 May 2022',
        text: 'Dataset of "A New Realistic Benchmark for Advanced Persistent Threats in Network Traffic, IEEE Networking Letters" is available for research use as long as the article is attributed properly and can be accessed from here ',
        link: 'https://ieee-dataport.org/documents/scvic-apt-2021'
    },
    {
        date: '18 May 2022',
        text: 'Our article (and a new public data set to use in cybersecurity research!) has been accepted to IEEE Networking Letters. J. Liu, Y. Shen, M. Simsek, B. Kantarci, H. Mouftah, M. Bagheri, P. Djukic, A New Realistic Benchmark for Advanced Persistent Threats in Network Traffic, IEEE Networking Letters, 2022. To view article',
        link: 'https://ieeexplore.ieee.org/document/9803189'
    },
    
    {
        date: '18 May 2022',
        text: 'Dr. Kantarci has been appointed as IEEE Systems Council Distinguished Lecturer for 2022-2024',
        link: ''
    },
    {
        date: '16 May 2022 ',
        text: 'Our article "A Tutorial on AI-Powered 3D Deployment of Drone Base Stations: State of the Art" has been accepted to Elsevier Vehicular Communications, Congrats Nahid, and thanks to all co-authors.  ',
        link: 'https://authors.elsevier.com/a/1f4w77tS-P~a9L '
    },
    {
        date: '07 Apr 2022 ',
        text: 'Our article "Machine Learning-Enabled IoT Security: Open Issues and Challenges Under Advanced Persistent Threats" has been accepted to ACM Computing Surveys. Congrats Zhiyan, Jinxin, Yu and thanks to all co-authors. ',
        link: 'https://dl.acm.org/doi/10.1145/3530812 '
    },
    {
        date: '03 Mar 2022',
        text: 'Our Smart Connected Innovation Centre (SCVIC) has been featured in Canada\'s Innovation Leaders ',
        link: 'https://twitter.com/BurakKantarci/status/1501233494332252162/photo/3'
    },
    {
        date: '01 Mar 2022',
        text: 'Dr. Kantarci is listed among top Computer Scientists in Canada in 2021. To view at Research.com ',
        link: 'https://research.com/scientists-rankings/computer-science/ca?page=4'
    },
    {
        date: '21 Jan 2022 ',
        text: 'Dr. Kantarci is listed among top-Computer Scientists in Canada',
        link: 'https://research.com/scientists-rankings/computer-science/ca?page=4 '
    },
    {
        date: '21 Jan 2022',
        text: 'Dr. Kantarci received a Minister\'s Award of Excellence in the category of Innovation and Entrepreneurship from Ontario Ministry of Colleges and Universities.',
        link: 'https://www.linkedin.com/feed/update/urn:li:activity:6897276130748174336/'
    },
    {
    date: '18 Dec 2021 ',
    text: 'Our article titled "Adversarial Machine Learning: A Multi-Layer Review of the State-of-the-Art and Challenges for Wireless and Mobile Systems " in IEEE Communications Surveys and Tutorials is now available as early access paper. Congratulations Jinxin and Johan. Thank you Dr. Michele Nogueira for the fruitful collaboration.',
    link: 'https://ieeexplore.ieee.org/document/9653662 '
    },
    {
        date: '9 Dec 2021 ',
        text: 'Our paper titled "𝐀𝐥𝐥 𝐏𝐫𝐞𝐝𝐢𝐜𝐭 𝐖𝐢𝐬𝐞𝐬𝐭 𝐃𝐞𝐜𝐢𝐝𝐞𝐬: 𝐀 𝐍𝐨𝐯𝐞𝐥 𝐄𝐧𝐬𝐞𝐦𝐛𝐥𝐞 𝐌𝐞𝐭𝐡𝐨𝐝 𝐓𝐨 𝐃𝐞𝐭𝐞𝐜𝐭 𝐈𝐧𝐭𝐫𝐮𝐬𝐢𝐯𝐞 𝐓𝐫𝐚𝐟𝐟𝐢𝐜 𝐈𝐧 𝐈𝐨𝐓 𝐍𝐞𝐭𝐰𝐨𝐫𝐤𝐬" has received the BEST PAPER AWARD in IEEE Global Communications Conference (Globecom) 2021 [under Communication QoS, Reliability and Modeling]. Congratulations to the team: Zhiyan Chen, Murat simsek, Petar Djukic. ',
        link: 'https://www.linkedin.com/posts/bkantarci_ieee-activity-6876871491913359360-guq7 '
    },
    {
        date: '14 Dec 2021 ',
        text: 'Our article titled "Machine Learning-Backed Planning of Rapid COVID-19 Tests With Autonomous Vehicles With Zero-Day Considerations" in IEEE Transactions on Emerging Topics in Computational Intelligence is now available.  ',
        link: 'https://ieeexplore.ieee.org/document/9647946 '
    },
    {
        date: '29 Oct 2021 ',
        text: 'Drones, bots and self-driving cars: How this new Kanata North innovation centre will help drive the future of autonomous vehicles ',
        link: 'https://www.uottawa.ca/gazette/en/news/drones-bots-and-self-driving-cars-how-new-kanata-north-innovation-centre-will-help-drive-future '
    },
    {
        date: '22 Oct 2021 ',
        text: 'As in last year, Dr. Kantarci is listed in the top 2%  most cited researchers in the field of networking and telecommunications. Researchers at Stanford University used the Scopus database and calculated different metrics and a composite metric to compare scientists in the same research. ',
        link: 'https://t.co/M8cPRsjPzr?amp=1 '
    },
    {
        date: '28 Sep 2021 ',
        text: 'Dr. Kantarci is a panelist in uOttawa Innovates Panel “How AI is addressing Security for Smart Critical Infrastructure” on 28 September 2021 ',
        link: 'https://www.linkedin.com/posts/faculty-of-engineering-uottawa_uottawa-innovates-ai-security-for-smart-activity-6847167228811501568-AG30 '
    },
    {
        date: '27 Sep 2021 ',
        text: 'Smart Connected Innovation Centre is featured in Ottawa Business Journal  ',
        link: 'https://obj.ca/article/Faculty-engineering-sponsored-creating-water-cooler-moments-drive-connected-car-innovation-kanata-north '
    },
    {
        date: '30 Aug 2021 ',
        text: 'Our article titled “All Predict Wisest Decides: A Novel Ensemble Method to Detect Intrusive Traffic in IoT Networks” has been accepted to IEEE Networking Letters. Congrats Yuwei!  ',
        link: 'https://ieeexplore.ieee.org/stamp/stamp.jsp?tp=&arnumber=9524823 '
    },
    {
        date: '24 Aug 2021 ',
        text: 'Dr. Kantarci delivering invited talk in IEEE Congress on Intelligent and Service-Oriented Systems Engineering. “Adversarial Machine Learning-Driven Fake Task Anticipation in Mobile Crowdsensing Systems”  Kudos to Zhiyan Chen. ',
        link: ''
    },
    {
        date: '05 Aug 2021 ',
        text: 'Our article titled “Risk-Aware Fine-Grained Access Control in Cyber-Physical Contexts” has been accepted to ACM Digital Threats: Research and Practice. Congrats Jason!  ',
        link: 'https://arxiv.org/ftp/arxiv/papers/2108/2108.12739.pdf '
    },
    {
        date: '02 Aug 2021 ',
        text: 'Our article titled “Transit networks, social contacts and open data meet public transportation plans for post-COVID-19: A Canadian case study” has been accepted to IEEE Engineering Management Review.  Congrats Oliver Benning and Jonathan Calles!  ',
        link: 'https://ieeexplore.ieee.org/stamp/stamp.jsp?tp=&arnumber=9511203 '
    },
    {
        date: '02 July 2021 ',
        text: 'Dr. Kantarci is delivering a keynote in IEEE International Workshop on Decentralized AI and Computing on IoT. Keynote title: AI-Backed Threat Modeling and Defense Strategies in IoT Systems. Date: 14-16July 2021 ',
        link: 'https://sites.google.com/view/daci2021/home?authuser=0 '
    },
    {
        date: '30 June 2021 ',
        text: 'Dr. Kantarci is delivering a keynote titled in IEEE World Forum on the Itnernet of Things (WF-IoT 2021) Workshop on Wireless Intelligent Secure Trustable Things: bringing IoT and AI together. Keynote Title: ',
        link: 'https://www.linkedin.com/posts/bkantarci_i-am-speaking-at-7th-ieee-world-forum-on-activity-6815275128348258306-gjPO '
    },
    {
        date: '03 May 2021 ',
        text: '34th IEEE Canadian Conference on Electrical and Computer Engineering now has a "Cybersecurity in Systems" track co-chaired by Dr. Kantarci. (Submit by May 21st.) ',
        link: 'https://ccece2021.ieee.ca/about/topics-of-interest/ '
    },
    {
        date: '29 Apr 2021 ',
        text: 'Dr. Kantarci is speaking at IoT North\'s ThinkFest 3.0 on Smart, Connected and Secure Communities via AI-Backed IoT Services. For the Program ',
        link: 'http://praxiem.com/iotnorth-thingkfest-3-0/ '
    },
    {
        date: '19 Mar 2021 ',
        text: 'Dr. Kantarci is Security and Privacy Track Co-Chair of IEEE International Smart Cities Conference (ISC2 2021). (Visit web site for important dates) ',
        link: 'https://attend.ieee.org/isc2-2021/oc/ '
    },
    {
        date: '27Jan2021 ',
        text: 'Dr. Kantarci is delivering an ACM Distinguished Speaker talk on the trustworthiness of crowdsensed data in the ACM Washington DC Meetup event. For Announcement and Registration',
        link: 'https://www.linkedin.com/feed/update/urn:li:activity:6758482635246313472/ '
    },
    {
        date: '17 Jan 2021 ',
        text: 'Our paper has been accepted to Elsevier Journal of System Architecture. Congratulations Zhiyan Chen, and thanks to Claudio Fiandrino for collaborating on this work. "On blockchain integration into mobile crowdsensing via smart embedded devices" ',
        link: 'https://reader.elsevier.com/reader/sd/pii/S1383762121000229 '
    },
    {
        date: '22 Jan 2021 ',
        text: 'Upcoming seminar by Prof. Erol Gelenbe” ',
        link: 'http://nextconlab.ca/event.html '
    },
    {
        date: '09 Dec 2020 ',
        text: 'Dr. Kantarci was a panelist in CAV Canada2020 Panel: “How CAVs will impact society?” For Video ',
        link: 'https://youtu.be/YipJrqZea5E?t=3256 '
    },
    {
        date: '23 Nov 2020   ',
        text: 'Our  Smart Connected Vehicles Innovation Lab. project and its vision covered in Ottawa Business Journal, For More News ',
        link: 'https://obj.ca/index.php/article/faculty-of-engineering-sponsored-uottawa-kanata-north-ramping-smart-connected-vehicles-innovation-lab '
    },
    {
        date: '11Nov2020 ',
        text: 'Dr. Kantarci is listed in the top 2%  most cited researchers in the field of networking and telecommunications. Researchers at Stanford University used the Scopus database and calculated different metrics and a composite metric to compare scientists in the same research. ',
        link: 'https://journals.plos.org/plosbiology/article?id=10.1371/journal.pbio.3000918 '
    },
    {
        date: '19 Oct 2020 ',
        text: 'Dr. Kantarci has been awarded the Association of Computing (ACM) Senior Member recognition. (List of North American awardees in 2020) ',
        link: 'https://awards.acm.org/senior-members/award-winners?year=2020&award=159&region=North+America&submit=Submit&isSpecialCategory= '
    },
    {
        date: '1O oct 2020 ',
        text: 'Our article titled \'Locally reconfigurable Self Organizing Feature Map for high impact malicious tasks submission in Mobile Crowdsensing\' has been accepted to Elsevier Internet of Things Journal. Congrats Xuankai!  ',
        link: 'https://reader.elsevier.com/reader/sd/pii/S2542660520301293?token=4CA38B150272C1749E65CDB68FC1B8A93DC48B8C9A524FE4D1236ADFB4B498D57AF38670334FCBAD120A1406DCF688F7 '
    },
    {
        date: '1 Oct 2020 ',
        text: 'Our article titled ‘Towards ensuring the reliability and dependability of vehicular crowd-sensing data in GPS-less location tracking’ has been accepted to Elsevier Pervasive and Mobile Computing Journal. ',
        link: 'https://www.sciencedirect.com/science/article/abs/pii/S1574119220300973 '
    },

    {
        date: '18 Sep 2020 ',
        text: 'Our article titled: ‘Attention-Based Event Characterization for Scarce Vehicular Sensing Data’ has been accepted to IEEE Open Journal of Vehicular Technology. Congrats Nima. For Paper ',
        link: 'https://ieeexplore.ieee.org/stamp/stamp.jsp?tp=&arnumber=9200673 '
    },
    {
        date: '17 Aug 2020 ',
        text: 'Dr. Kantarci has received the Canada Foundation for Innovation’s John R. Evans Leaders Fund  ',
        link: 'https://twitter.com/uOttawaGenie/status/1295795013201395713?s=20 '
    },
    {
        date: '23 July 2020 ',
        text: 'Our article titled "Empowering Self-Organized Feature Maps for AI-Enabled Modelling of Fake Task Submissions to Mobile Crowdsensing Platforms" has been accepted to IEEE Internet of Things Journal ',
        link: 'https://ieeexplore.ieee.org/document/9146523 '
    },
    {
        date: '9 July 2020 ',
        text: 'Our article titled "Ensemble Methods for the Detection of Fake Tasks in Mobile Crowdsensing under Limited Training Data" has been accepted to IEEE Vehicular Technology Magazine ',
        link: 'https://ieeexplore.ieee.org/document/9137680 '
    },
    {
        date: '3 June 2020 ',
        text: 'Dr. Kantarci has been awarded the NSERC Alliance Grant to battle the COVID-19 Crisis with research “Artificial Intelligence-Based Decision Support System for COVID-19 Mobile Assessments and Optimal Supply Services During the Pandemic” ',
        link: 'https://www.linkedin.com/posts/bkantarci_covid19canada-artificialintelligence-ai-activity-6674037387976327168-EkBb '
    },
    {
        date: '11May 2020 ',
        text: 'NEXTCON to help resolve COVID-19: Our initial research results to help resolve COVID-19 crisis published in Intl. Journal of Environmental Research and Public Health (IF: 2.468).  ',
        link: 'https://www.mdpi.com/1660-4601/17/10/3437/pdf '
    },
    {
        date: ' 22 April 2020',
        text: 'Congratulations to NEXTCON’s Ji Chu Jiang for his first accepted paper. “High Precision Deep Learning-Based Tabular Detection” accepted to IEEE Symposium on Computers and Communications (ISCC). Way to go, Ji Chu! ',
        link: 'https://ieeexplore.ieee.org/document/9219583 '
    },
    {
        date: '26 Feb 2020 ',
        text: 'Another proud moment for NEXTCON lab. Xuankai Chen has won the 2nd Prize for the Fall 2019 Cognos Prize at uOttawa for his Honours thesis titled “Artificial Neural Networks-assisted Data Acquisition in Mobile Crowdsensing Systems”. Congrats Xuankai! ',
        link: 'https://www.linkedin.com/posts/bkantarci_nextconlab-ai-machinelearning-activity-6638568955067801600-Q5LL '
    },
    {
        date: '27 Jan 2020 ',
        text: 'Three papers on AI-backed security accepted to IEEE International Conference on Communications (ICC 2020) Congratulations to Zhiyan Chen, Yueqian Zhang, Safa Otoum!  ',
        link: 'https://www.linkedin.com/posts/bkantarci_ieee-international-conference-on-communications-activity-6627685929802878976-vRn6 '
    },
    {
        date: '20 Jan 2020 ',
        text: 'Four researchers of NEXTCON Lab participated in CANDEV Data Challenge presented by Statistics Canada on 18-19 January with their "AI Model for Enabling Smart Cities" in the smart cities innovation challenge.  ',
        link: 'https://www.linkedin.com/posts/bkantarci_candev-nextconlab-activity-6625194913736781824-2sq7 '
    },
    {
        date: '19 Dec 2019 ',
        text: 'Yueqian “Audrey” Zhang ; and Ahmed Omara have defended their Master’s theses successfully. Theses titled "Resource Clogging Attacks in Mobile Crowd-Sensing: AI-based Modeling, Detection and Mitigation" and  “Predictive Operational Strategies for Smart Microgrid Networks”. Congrats Audrey! Congrats Ahmed! ',
        link: 'https://www.linkedin.com/posts/bkantarci_nextconlab-smartcities-ai-activity-6613569933097877504-2jFP '
    },
    {
        date: '28 Nov2019 ',
        text: 'Dr. Kantarci is delivering a talk titled "Bridging AI and Adversarial AI for secure non-dedicated sensing in smart spaces" the Ottawa AI Alliance – Second Annual Workshop. ',
        link: ''
    },
    {
        date: '16 Oct 2019 ',
        text: 'Dr. Kantarci is invited speaker with his talk titled "Mobile Crowdsensing for Crowd Management in Disasters: Challenges, Solutions, Opportunities" in dedicated" and "non-dedicated" sensor networks against misbehavior" in 8th MC/WG Meeting of Resilient Communication Services Protecting End-user Applications from Disaster-based Failures (RECODIS) in Nicosia, Cyprus. ',
        link: ''
    },
    {
        date: '14 Oct 2019 ',
        text: 'Dr. Kantarci delivers keynote speech titled "AI-backed resiliency for "dedicated" and "non-dedicated" sensor networks against misbehaviour" in 11th International Workshop on Resilient Networks Design and Management (RNDM) in Nicosia, Cyprus. ',
        link: ''
    },
    {
        date: '4 Oct 2019 ',
        text: 'Our AVIN Talent Edge project "Vehicular Sensor Fusion for Detection and Characterization of Significant Events" has been approved for funding by Ontario Centres of Excellence (OCE). ',
        link: ''
    },
    {
        date: '30 July 2019 ',
        text: 'Our article titled "Towards Fog-Based Mobile Crowdsensing Systems: State of the Art and Opportunities" has been accepted to IEEE Communications Magazine. Congratulations Dimitri! ',
        link: ''
    },
    {
        date: '17 July 2019 ',
        text: 'Dr. Kantarci\'s MITACS Accelerate application, AI-Based Automated Methodologies for Supply Chains has been awarded. 3-year collaboration with our industry partner. Total project budget: $270K ',
        link: ''
    },
    {
        date: '15 July 2019 ',
        text: 'Two papers accepted to Globecom 2019. Both on adversarial machine learning. Congratulations Audrey, Kyle, Ertugrul. ',
        link: ''
    },
    {
        date: '25 June 2019 ',
        text: 'NEXTCON Lab is on the news with AI and connected vehicles research. (link) ',
        link: 'https://obj.ca/article/uottawa-engineering-search-safer-cities-university-ottawa-researchers-eye-new-uses-big-data-and-vehicular-crowd '
    },
    {
        date: '25 June 2019 ',
        text: 'Our article titled "article A Survey on Cybersecurity, Data Privacy, and Policy Issues in Cyber-Physical System Deployments in Smart Cities" is now available in Elsevier Sustainable Cities and Society. For PDF ',
        link: 'https://authors.elsevier.com/c/1ZLGn7sfVYuN5J '
    },
    {
        date: '25 June 2019 ',
        text: 'Venkat Dasari and Ertugrul Kara have successfully defended their Master\'s theses. Congratulations! ',
        link: ''
    },
    {
        date: '21 May 2019 ',
        text: 'Proud moment for NEXTCON lab. Mark Traquair has been awarded Winter 2019 Cognos Prize at uOttawa for his Honours thesis which was a part of our collaboration with Lytica. ',
        link: 'https://www.linkedin.com/feed/update/urn:li:activity:6537304107202543616 '
    },
    {
        date: '30 Apr 2019 ',
        text: 'Our article "A Survey on Mobile Crowdsensing Systems: Challenges, Solutions and Opportunities" in IEEE Communications Surveys and Tutorials is now online. ',
        link: 'https://ieeexplore.ieee.org/document/8703108 '
    },
    {
        date: '29 Mar 2019 ',
        text: 'Dr. Kantarci has been granted tenure and promotion to Associate Professor, effective 1 May 2019. ',
        link: ''
    },
    {
        date: '15 Feb 2019 ',
        text: 'Dr. Kantarci is the Chair for Big Data Science and Analytics Track of the 5th IEEE Intl. Conference on Cloud and Big Data Computing (CBDCom 2019). For detail or submitting paper',
        link: 'http://cyber-science.org/2019/cbdcom/ '
    },
    {
        date: '03 Feb 2019 ',
        text: 'Two papers accepted to ICC 2019. One on reinforcement learning-based intrusion detection on big sensed data; the other on ML-driven microgrid data aggregation over HetNets. Congratulations Safa and Ahmed!. ',
        link: ''
    },
    {
        date: '17 Dec 2018 ',
        text: 'Dr. Kantarci has been appointed as a Distinguished Speaker of the ACM. Kantarci’s term as a distinguished speaker is for three years.  Dr. Kantarci can be invited as an ACM speaker to deliver the available lectures by using the forms  ',
        link: 'https://speakers.acm.org/speakers/kantarci_10609 '
    },
    {
        date: '14 Dec 2018 ',
        text: 'Our paper titled “Big data aggregation in the case of heterogeneity: A feasibility study for Digital Health” has been accepted by Springer Journal of Machine Learning and Cybernetics. Congratulations Alex. ',
        link: ''
    },
    {
        date: '11 Dec 2018 ',
        text: 'Dr. Kantarci is the Chair of IEEE Communication Systems Integration and Modeling (CSIM) Technical Committee. Thanks to past chair Christos Verikoukis for his several years of service to CSIM, and welcome new officers Nizar zorba (vice-chair) and Angelos Antonopoulos (secretary). ',
        link: ''
    },
    {
        date: '22 Nov 2018 ',
        text: 'Dr. Kantarci’s Voucher for Innovation and Productivity (VIP I) Program Project proposal on continuous authentication has been approved by Ontario Centres of Excellence (OCE). ',
        link: ''
    },
    {
        date: '24 Oct 2018 ',
        text: 'Our paper on sensing, communications and security planes of smart cities has been published in Elsevier Computer Networks. For PDF ',
        link: 'https://www.sciencedirect.com/science/article/pii/S1389128618306534/pdfft?md5=0e9573dc0f8beb6927fb5a0d36bc743f&pid=1-s2.0-S1389128618306534-main.pdf '
    },
    {
        date: '25 Jul 2018 ',
        text: 'Cem Kaptan has defended his Master\'s thesis titled “Machine Learning-driven Vehicular Crowd-Sensing for urban transportation services”. Congratulations Cem! ',
        link: ''
    },
    {
        date: '10 Jul 2018 ',
        text: 'Two papers accepted to Globecom 2018. One on mobile crowd-sensing, the other on vehicular crowd-sensing. Congratulations Maryam and Cem! ',
        link: ''
    },
    {
        date: '19 April 2018 ',
        text: 'Zachary I. Rauen has defended his MSc thesis (in Electrical Engineering) successfully at Clarkson University. Congratulations, Zack! Best wishes for a bright career path. ',
        link: ''
    },
    {
        date: '29 Mar 2018 ',
        text: 'Ph.D candidates Maryam Pouryazdan and Fazel Anjomshoa have defended their theses successfully at Clarkson. Congratulations, Maryam and Fazel! Best wishes for your bright career paths. For images ',
        link: 'http://www.site.uottawa.ca/~bkantarc/nextcon/MaryamFazelDefence.jpg '
    },
    {
        date: '29 Mar 2018',
        text: 'Dr. Kantarci\'s Voucher for Innovation and Productivity (VIPI) Program Project proposal in partnership with Gnowit has been approved by Ontario Centres of Excellence (OCE). ',
        link: ''
    },
    {
        date: '08 Mar 2018 ',
        text: 'Three papers from our group have been accepted to IEEE Intl. Conference on Communications (ICC\'18). "Adaptively Supervised and Intrusion-Aware Data Aggregation for Wireless Sensor Clusters in Critical Infrastructures"; "Emulating Smart City Sensors Using Soft Sensing and Machine Intelligence: a Case Study in Public Transportation"; "MQTT-Driven Sustainable Node Discovery for the Internet of Things-Fog Environments". Congratulations to Safa, Cem and Riccardo! One paper titled Selective Versus Non-Selective Acquisition of Crowd-Solicited IoT Data and its Dependability has also been accepted to an ICC Workshop. (Cem Kaptan and Venkat Surya Dasari publish their first papers; welcome on board!) ',
        link: ''
    },
    {
        date: '24 Nov 2017 ',
        text: 'Our article titled "Collaborative Verification of Smart User Profiles for social sustainability of smart cities" has been accepted to Elsevier Sustainable Cities and Society journal\'s Special Issue on Role of Big Data Analytics in a Sustainable Smart City. Paper co-authored with two undergraduate students. This is an outcome of the uOttawa work-study program. Phil, Victor, thank you both for the great work! ',
        link: ''
    },
    {
        date: '17 Nov 2017 ',
        text: 'Our article titled "Big Sensed Data Meets Deep Learning for Smarter Health Care in Smart Cities" has been accepted to the special issue of Sensors and Actuators for Smart Cities in the Journal of Sensor and Actuator Networks. Congratulations Alex. For PDF ',
        link: 'http://www.mdpi.com/2224-2708/6/4/26/pdf '
    },
    {
        date: '12 Oct 2017 ',
        text: 'Our article titled "Intelligent Gaming for Mobile Crowd-sensing Participants to Acquire Trustworthy Big Data in the Internet of Things" has been accepted to IEEE Access journal. Congratulations Maryam. For PDF ',
        link: 'http://ieeexplore.ieee.org/ielx7/6287639/6514899/08064624.pdf?tp=&arnumber=8064624&isnumber=6514899 '
    },
    {
        date: '1 Oct 2017 ',
        text: 'Our article titled "Detection of Known and Unknown Intrusive Sensor Behavior in Critical Applications" has been published in IEEE Sensors Letters. Congratulations Safa. For PDF ',
        link: 'http://ieeexplore.ieee.org/ielx7/7782634/8010956/08038076.pdf?tp=&arnumber=8038076&isnumber=8010956 '
    },
    {
        date: '29 Aug 2017 ',
        text: 'PhD candidate Fazel Anjomshoa has been accepted to the Insight Data Science Fellows Program, and will join the program on Sep. 5th. ',
        link: ''
    },
    {
        date: '29 Aug 2017 ',
        text: 'Maryam Pouryazdan and Fazel Anjomshoa have passed their PhD proposal exams. Maryam and Fazel are now officially PhD candidates. Congrats both! ',
        link: ''
    },
    {
        date: '23 Aug 2017 ',
        text: 'Safa Otoum has passed her PhD proposal exam. She is officially a PhD candidate now! Congrats Safa! ',
        link: ''
    },
    {
        date: '2 Aug 2017 ',
        text: 'New paper accepted to IEEE PIMRC\'17. CD-ASM: A New Queuing Paradigm to Overcome Bufferbloat Effects in HetNets. Collaboration initiated by Drs. Michele Nogueira and Aldri Santos from UFPR-Brazil. Colegas, muito obrigado! ',
        link: ''
    },
    {
        date: '28 Jul 2017 ',
        text: 'Our paper with two undergrads accepted to IEEE Global Signal and Information Processing (GlobalSIP) Symposium. Title: Participatory detection of identity theft on mobile social platforms. This is an outcome of the uOttawa work-study program. Phil, Victor, thank you both for the good work! ',
        link: ''
    },
    {
        date: '11 July 2017 ',
        text: 'Our article on non-dedicated sensing and smart cities has been accepted to IEEE Sensors Journal. For PDF ',
        link: 'http://ieeexplore.ieee.org.proxy.bib.uottawa.ca/stamp/stamp.jsp?tp=&arnumber=7973152 '
    },
    {
        date: '26 June 2017 ',
        text: 'Our article on Social Behaviometrics in IoT have been accepted to IEEE Access. Congrats to Fazel and Moayad. ',
        link: 'http://ieeexplore.ieee.org/stamp/stamp.jsp?arnumber=7959042 '
    },
    {
        date: '22 May 2017 ',
        text: 'Dr. Kantarci elevates to the vice-chair of IEEE Communication Systems Integration and Modelling Technical Committee (CSIM-TC). ',
        link: ''
    },
    {
        date: '13 Apr 2017 ',
        text: 'Dr. Kantarci receives NSERC DISCOVERY grant for the project titled "Mobile social network analytics and mobile edge solutions for trustworthy and reliable urban sensing". ',
        link: ''
    },
    {
        date: '28 Mar 2017 ',
        text: 'Two papers accepted to IWCMC 2017. Congratulations to Safa Otoum! Thanks to Moayad Aloqaily! ',
        link: ''
    },
    {
        date: '10 Feb 2017 ',
        text: 'Our article on "Crowdsensim simulator" has been publishedin IEEE Access journal. Thank you Claudio for leading this initiative and thanks to all our collaborators! For PDF ',
        link: 'http://ieeexplore.ieee.org/stamp/stamp.jsp?tp=&arnumber=7859284 '
    },
    {
        date: '26 Jan 2017',
        text: 'Two papers have been accepted to IEEE ICC\'17. One paper on blackhole detection in WSN-based smart grid monitoring (with PhD student Safa Otoum), and the other paper on sociability-based continuous identification (with PhD student, Fazel Anjomshoa). Congratulations Safa and Fazel! ',
        link: ''
    },
    {
        date: '21 Jan 2017 ',
        text: 'Our article titled "Quantifying User Reputation Scores, Data Trustworthiness, and User Incentives in Mobile Crowd-Sensing" has been accepted to IEEE Access special section on Big Data Analytics in Internet-of-Things And Cyber-Physical System. The article is co-authored with PhD student Maryam Pouryazdan. Congratulations Maryam! For PDF ',
        link: 'http://ieeexplore.ieee.org/stamp/stamp.jsp?tp=&arnumber=7835651 '
    },
    {
        date: '16 Jan 2017 ',
        text: 'Dr. Kantarci is the IEEE Communications Society representative in the steering committee of IEEE Transactions on Cloud Computing. ',
        link: ''
    },
    {
        date: '03 Sep 2016 ',
        text: 'Our article "Machine Learning in Cardiac Health Monitoring and Decision Support" has been accepted to the Smart Health and Well Being Special Issue of IEEE Computer. This is in collaboration with SUNY at Albany and Univ. Rochester. Thank you all! ',
        link: ''
    },
    {
        date: '22 Aug 2016 ',
        text: 'Dr. Kantarci is an Area Editor for IEEE Transactions on Green Communications and Networking in the area of energy efficiency in data storage and sensors. ',
        link: 'http://www.comsoc.org/tgcn '
    },

        

];